// extracted by mini-css-extract-plugin
export var childrenContainer = "_dc-0";
export var virtualScrollArea = "_dc-1";